import React, { Fragment, memo, useCallback, useState } from 'react'
import { Route, Switch } from 'react-router-dom'

import ErrorPage from '../pages/ErrorPage'
import Paper from '@material-ui/core/Paper'
import ScreenWidth from '../components/debug/ScreenWidth'
import { makeStyles } from '@material-ui/core/styles'
import LOG from '../logging/Logger'

const debugViews = false

const useStyles = makeStyles(theme => ({
  toolbar: theme.mixins.toolbar,
  content: {
    flexGrow: 1,
    backgroundColor: theme.palette.background.default,
    padding: theme.spacing(1),
    // Be careful if seeting minHeight - it can cause the virtual list to render everything
    height: 'calc(100vh - 24px)',
    [theme.breakpoints.only('xs')]: {
      padding: 0
    }
  },
  paper: {
    padding: theme.spacing(1.5, 1.5, 1, 1.5),
    marginTop: 0,
    overflowX: 'hidden',
    overflowY: 'auto',
    // Be careful if seeting minHeight - it can cause the virtual list to render everything
    height: 'calc(100% - 68px)'
  }
}))

export default memo(
  ({
    navigation,
    getTodos,
    decrypt,
    editTodoStatus,
    getRepeatPattern,
    getProjectNameForTodo,
    redirectToProject,
    getProjectsForAreas,
    clientId,
    createProject,
    deleteTodo,
    getProjectById,
    editTodo,
    getAvailableTags,
    createTodo,
    getAreas,
    editProject,
    deleteProject,
    handleTodoDragEnd,
    moveTodoToTrash,
    cacheDragList,
    getTagsFromTodo,
    createAttachment,
    deleteAttachment,
    editAttachment,
    downloadAttachment,
    getTodoAttachments,
    setInfo,
    setWarning,
    setError,
    getAreaById
  }) => {
    LOG.debug('Render: Main')

    const classes = useStyles()

    const [scrollRef, setScrollRef] = useState(null)

    const renderChild = useCallback(
      (props, item) => (
        <item.component
          {...props}
          scrollRef={scrollRef}
          getTodos={getTodos}
          decrypt={decrypt}
          editTodoStatus={editTodoStatus}
          getRepeatPattern={getRepeatPattern}
          getProjectNameForTodo={getProjectNameForTodo}
          redirectToProject={redirectToProject}
          getProjectsForAreas={getProjectsForAreas}
          clientId={clientId}
          createProject={createProject}
          deleteTodo={deleteTodo}
          getProjectById={getProjectById}
          editTodo={editTodo}
          getAvailableTags={getAvailableTags}
          createTodo={createTodo}
          getAreas={getAreas}
          editProject={editProject}
          deleteProject={deleteProject}
          handleTodoDragEnd={handleTodoDragEnd}
          moveTodoToTrash={moveTodoToTrash}
          cacheDragList={cacheDragList}
          getTagsFromTodo={getTagsFromTodo}
          createAttachment={createAttachment}
          deleteAttachment={deleteAttachment}
          editAttachment={editAttachment}
          downloadAttachment={downloadAttachment}
          getTodoAttachments={getTodoAttachments}
          setInfo={setInfo}
          setWarning={setWarning}
          setError={setError}
          getAreaById={getAreaById}
        />
      ),
      [
        getTodos,
        decrypt,
        editTodoStatus,
        getRepeatPattern,
        getProjectNameForTodo,
        redirectToProject,
        getProjectsForAreas,
        clientId,
        createProject,
        deleteTodo,
        getProjectById,
        editTodo,
        getAvailableTags,
        createTodo,
        getAreas,
        editProject,
        deleteProject,
        handleTodoDragEnd,
        moveTodoToTrash,
        cacheDragList,
        getTagsFromTodo,
        createAttachment,
        deleteAttachment,
        editAttachment,
        downloadAttachment,
        getTodoAttachments,
        scrollRef,
        setInfo,
        setWarning,
        setError,
        getAreaById
      ]
    )

    return (
      <main className={classes.content}>
        <div className={classes.toolbar} />
        <Paper className={classes.paper} ref={el => setScrollRef(el)}>
          {debugViews && (
            <Fragment>
              <ScreenWidth />
            </Fragment>
          )}

          <Switch>
            {navigation.map(item => (
              <Route
                key={item.id}
                exact
                path={item.path}
                render={props => renderChild(props, item)}
              />
            ))}
            <Route path='/*' render={props => <ErrorPage {...props} />} />
          </Switch>
        </Paper>
      </main>
    )
  }
)
